<template>
  <div class="page-container">
    <div v-if="loading" class="text-tertiary text-sm text-center" style="padding:40px 0">Loading...</div>
    <template v-else-if="comment">
      <router-link :to="'/blog/' + comment.post_id" class="back-link">&larr; {{ $t('back_to_blog') }}</router-link>
      <div class="detail-header">
        <span class="detail-username">{{ comment.username }}</span>
        <span v-if="comment.is_admin" class="admin-badge">A</span>
        <span class="text-tertiary text-xs ml-1">{{ formatDate(comment.created_at) }}</span>
      </div>
      <div class="detail-content">{{ comment.content }}</div>
      <div class="detail-divider" />
      <div class="detail-replies-header text-secondary text-sm">
        {{ $t('reply_count') }} ({{ totalReplies }})
      </div>
      <div v-if="comment.children && comment.children.length > 0" class="detail-replies">
        <CommentItem
          v-for="child in comment.children"
          :key="child.id"
          :comment="child"
          :depth="0"
          :postId="comment.post_id"
          @refresh="fetchComment"
        />
      </div>
      <div v-else class="text-tertiary text-sm text-center mt-2">{{ $t('no_comments') }}</div>
    </template>
    <div v-else class="text-tertiary text-sm text-center" style="padding:40px 0">{{ $t('not_found') }}</div>
  </div>
</template>

<script>
import api from '../api'
import CommentItem from '../components/CommentItem.vue'

export default {
  name: 'CommentDetail',
  components: { CommentItem },
  data() {
    return { comment: null, loading: true }
  },
  computed: {
    commentId() { return Number(this.$route.params.id) },
    totalReplies() {
      if (!this.comment || !this.comment.children) return 0
      const count = (list) => { let n = 0; for (const c of list) n += 1 + count(c.children || []); return n }
      return count(this.comment.children)
    }
  },
  methods: {
    formatDate(d) {
      if (!d) return ''
      return new Date(d).toLocaleDateString(this.$i18nState.lang === 'en' ? 'en-US' : 'zh-CN', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    fetchComment() {
      this.loading = true
      api.get('/comments/' + this.commentId).then(res => {
        this.comment = res.data.data
      }).catch(() => {
        this.comment = null
      }).finally(() => { this.loading = false })
    }
  },
  mounted() { this.fetchComment() }
}
</script>

<style scoped>
.back-link { display: inline-block; font-size: 0.85rem; color: var(--text-tertiary); margin-bottom: 24px; }
.back-link:hover { color: var(--text-primary); }
.detail-header { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.detail-username { font-size: 1rem; font-weight: 600; }
.admin-badge { font-size: 0.65rem; font-weight: 700; background: var(--text-primary); color: var(--bg-primary); padding: 1px 5px; border-radius: 3px; }
.detail-content { font-size: 0.95rem; line-height: 1.7; margin-bottom: 24px; white-space: pre-wrap; word-break: break-word; }
.detail-divider { height: 1px; background: var(--border-light); margin: 24px 0 16px; }
.detail-replies-header { margin-bottom: 8px; }
.detail-replies { margin-top: 8px; }
</style>
